import { Link } from "react-router-dom";
import { Shield, Globe, Share2, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-neutral-900 text-neutral-400 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-3 mb-6 text-white">
              <Shield className="w-8 h-8" />
              <span className="text-xl font-bold">Portal Ethics</span>
            </div>
            <p className="text-sm leading-relaxed mb-6">
              Excelência em compliance, integridade e governança corporativa desde 2015. 
              Transformando culturas organizacionais através da transparência.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-white transition-colors">
                <Globe className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Share2 className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h6 className="text-white font-bold mb-6">Serviços</h6>
            <ul className="space-y-4 text-sm">
              <li><Link to="#" className="hover:text-white transition-colors">Canal de Ética</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Auditoria Externa</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Consultoria em Riscos</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Investigação Corporativa</Link></li>
            </ul>
          </div>

          {/* Institutional */}
          <div>
            <h6 className="text-white font-bold mb-6">Institucional</h6>
            <ul className="space-y-4 text-sm">
              <li><Link to="#" className="hover:text-white transition-colors">Quem Somos</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Nossos Planos</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Carreiras</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">LGPD & Termos</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h6 className="text-white font-bold mb-6">Assine nossa Newsletter</h6>
            <p className="text-xs mb-4">Fique por dentro das novidades do mundo do compliance.</p>
            <div className="flex">
              <input 
                type="email" 
                placeholder="Seu e-mail" 
                className="bg-white/5 border border-white/10 rounded-l-lg p-3 text-sm flex-1 focus:outline-none focus:border-primary-blue text-white"
              />
              <button className="bg-primary-blue text-white p-3 rounded-r-lg hover:bg-[#244F73] transition-colors">
                <Mail className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>&copy; 2024 Portal Ethics. Todos os direitos reservados.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-white">Privacidade</Link>
            <Link to="#" className="hover:text-white">Cookies</Link>
            <Link to="#" className="hover:text-white">Segurança</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
